import React from 'react';
import { FeaturedAppCard } from '../AppCard/FeaturedAppCard';
import { mockApps } from '../../utils/mockData';
import { useNavigate } from 'react-router-dom';
interface AppCardViewProps {
  onOpenApp: (appId: string) => void;
  createAppTile?: any;
}
export const AppCardView = ({
  onOpenApp,
  createAppTile
}: AppCardViewProps) => {
  const navigate = useNavigate();
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-241">
      {mockApps.map(app => <div key={app.id} onClick={() => navigate(`/app-interface/${app.id}`)} data-id="element-242">
          <FeaturedAppCard {...app} data-id="element-243" />
        </div>)}
    </div>;
};